import { NextRouter } from "next/router";
import { useEffect, useState } from "react";

/** プロジェクト詳細画面遷移時にRouterのパスからコース選択を表示するか否かを判別する */
export const useCourseListSwitch = (router: NextRouter): boolean => {
  const shouldShow = (path: string) => path.includes("#course");
  const [shownCourseList, setShownCourseList] = useState(false);
  const handler = (url: string) => {
    setShownCourseList(shouldShow(url));
  };
  useEffect(() => {
    router.events.on("hashChangeComplete", handler);
    return () => router.events.off("hashChangeComplete", handler);
  }, []);
  useEffect(() => {
    handler(router.asPath);
  }, [router]);
  useEffect(() => {
    const element = document.querySelector("body");
    if (element) {
      if (shownCourseList) {
        element.classList.add("returnOn");
      } else {
        element.classList.remove("returnOn");
      }
    }
    return () => document.querySelector("body")?.classList.remove("returnOn");
  }, [shownCourseList]);
  return shownCourseList;
};
